import request from '@/utils/request';

//新建货架
export const addShelf = (data) => {
  return request('/activityPoints/addShelf', {
    method: 'POST',
    data,
  });
};

//编辑货架
export const updateShelf = (data) => {
  return request('/activityPoints/updateShelf', {
    method: 'POST',
    data,
  });
};

//查询货架详情
export const getQueryShelfDetail = (data) => {
  return request('/activityPoints/queryShelfDetail', {
    method: 'POST',
    data,
  });
};

//查询礼品列表
export const getGiftList = (data) => {
  return request('/activityPoints/queryGiftPopPage', {
    method: 'POST',
    data,
  });
};

//校验删除货架
export const canDeleteGoodsShelf = (data) => {
  return request('/activityPoints/queryGiftExchange', {
    method: 'POST',
    data,
  });
};
